/* eslint-disable */
// @ts-nocheck
import * as React from 'react';
import { VariableSizeList } from 'react-window';
import Tooltip from '../../../../common/components/core/Tooltip';
import wrappedComponents from './components';
type MenuListProps = {
  options: any[];
  children: Node[];
  maxHeight: number;
  getValue: () => number[];
};
type MenuListOptionProps = {
  child: any;
  style: {
    height: number;
    left: number;
    position: string;
    top: number;
    width: string;
  };
};
const NUM_OPTIONS_FOR_VIRTUAL_LIST = 100;
const ROW_HEIGHT = 33;
const LIST_HEIGHT_BUFFER = 5;

const getRowHeight = (index: number): number => {
  return ROW_HEIGHT;
};

const getListHeight = (rowCount: number, maxHeight: number): number => {
  return Math.min(rowCount * ROW_HEIGHT + LIST_HEIGHT_BUFFER, maxHeight);
};

export default function MenuList(props: MenuListProps) {
  const { options, children, maxHeight, getValue } = props;
  const [value] = getValue();
  const initialOffset = options.indexOf(value) * ROW_HEIGHT;
  const listHeight = getListHeight(children.length, maxHeight);
  const numOptions = children.length || 0;

  if (numOptions < NUM_OPTIONS_FOR_VIRTUAL_LIST) {
    return <wrappedComponents.MenuList {...props} />;
  }

  return (
    <VariableSizeList
      height={listHeight}
      itemCount={children.length}
      itemSize={getRowHeight}
      initialScrollOffset={initialOffset}
      width={'100%'}
    >
      {({ index, style }) => <MenuListOption child={children[index]} style={style} />}
    </VariableSizeList>
  );
}

const MenuListOption = (props: MenuListOptionProps) => {
  const { child, style } = props;
  const childProps = {
    className: 'ellipses',
  };
  return (
    <div style={style}>
      <Tooltip
        delay={200}
        title={child.props.value}
        position="right"
        style={{
          display: 'inline-block',
          width: '100%',
        }}
      >
        {React.cloneElement(child, childProps)}
      </Tooltip>
    </div>
  );
};
